import { render, staticRenderFns } from "./ModalInsercaoArquivoOrdemDeCorte.vue?vue&type=template&id=1f3b28fe&lang=pug"
import script from "./ModalInsercaoArquivoOrdemDeCorte.vue?vue&type=script&lang=js"
export * from "./ModalInsercaoArquivoOrdemDeCorte.vue?vue&type=script&lang=js"
import style0 from "./ModalInsercaoArquivoOrdemDeCorte.vue?vue&type=style&index=0&id=1f3b28fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports